/**
 *
 * Preloader
 *
 */

import React, { memo } from 'react';
import classNames from 'classnames';

import useDeviceDetect from 'utils/useDeviceDetect';

// styles
import './style.scss';

// antd component
import { Spin } from 'antd';

// icons
//import CustomIcons from 'components/CustomIcons';

import { appHelper } from 'appCapacitor/helpers';

function Preloader({
  size,
  fullWidth,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('loading-preview', size, className);
  const { isMobile } = useDeviceDetect();

  return <Spin
    className={classNames(
      childClassNames,
      fullWidth && 'loading-preview--mobile',
      (isMobile || !appHelper.isWeb) && 'mobile'
    )}
    size={size}
    indicator={<div className='sp sp-sphere'></div>}
    {...rest}
  />;
}

Preloader.defaultProps = {
  size: 'large'
};
Preloader.propTypes = {};

export default memo(Preloader);
